import * as Yup from 'yup';
import { EDOZVOLA_WEB_ID_REGEX } from 'app/config/constants';

export const caseWebIdToCopyFromSchema = Yup.object({
  caseWebIdToCopyFrom: Yup.string().matches(EDOZVOLA_WEB_ID_REGEX, 'Unesena šifra predmeta je neispravna!'),
});
